import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const DSGVO = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#000',
        py: 8,
      }}
    >
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Button
            component={Link}
            to="/"
            startIcon={<ArrowBack />}
            sx={{
              mb: 4,
              color: 'white',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            Zurück zur Hauptseite
          </Button>

          <Typography
            variant="h2"
            sx={{
              mb: 4,
              fontWeight: 600,
              color: 'white',
            }}
          >
            Datenschutzerklärung
          </Typography>

          <Box
            sx={{
              bgcolor: 'rgba(255, 255, 255, 0.05)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: 3,
              p: 4,
              mb: 4,
            }}
          >
            <Typography
              variant="h5"
              sx={{
                mb: 2,
                fontWeight: 600,
                color: 'white',
              }}
            >
              1. Datenschutz auf einen Blick
            </Typography>

            <Typography
              variant="h6"
              sx={{
                mb: 1,
                fontWeight: 600,
                color: 'white',
              }}
            >
              Allgemeine Hinweise
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                lineHeight: 1.6,
                mb: 3,
              }}
            >
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
            </Typography>

            <Typography
              variant="h6"
              sx={{
                mb: 1,
                fontWeight: 600,
                color: 'white',
              }}
            >
              Datenerfassung auf dieser Website
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                lineHeight: 1.6,
                mb: 4,
              }}
            >
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen. Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
            </Typography>

            <Typography
              variant="h5"
              sx={{
                mb: 2,
                fontWeight: 600,
                color: 'white',
              }}
            >
              2. Allgemeine Hinweise und Pflichtinformationen
            </Typography>

            <Typography
              variant="h6"
              sx={{
                mb: 1,
                fontWeight: 600,
                color: 'white',
              }}
            >
              Datenschutz
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                lineHeight: 1.6,
                mb: 3,
              }}
            >
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzbestimmungen sowie dieser Datenschutzerklärung.
            </Typography>

            <Typography
              variant="h6"
              sx={{
                mb: 1,
                fontWeight: 600,
                color: 'white',
              }}
            >
              Hinweis zur verantwortlichen Stelle
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                lineHeight: 1.6,
                mb: 3,
              }}
            >
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br /><br />
              MJ Webagentur<br />
              Mustermann Straße 123<br />
              12345 Musterstadt<br />
              Deutschland<br /><br />
              Telefon: +49 123 456 789<br />
              E-Mail: info@mj-webagentur.de
            </Typography>

            <Typography
              variant="h6"
              sx={{
                mb: 1,
                fontWeight: 600,
                color: 'white',
              }}
            >
              Widerruf Ihrer Einwilligung zur Datenverarbeitung
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                lineHeight: 1.6,
                mb: 4,
              }}
            >
              Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
            </Typography>

            <Typography
              variant="h5"
              sx={{
                mb: 2,
                fontWeight: 600,
                color: 'white',
              }}
            >
              3. Datenerfassung auf dieser Website
            </Typography>

            <Typography
              variant="h6"
              sx={{
                mb: 1,
                fontWeight: 600,
                color: 'white',
              }}
            >
              Kontaktformular
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                lineHeight: 1.6,
                mb: 3,
              }}
            >
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </Typography>

            <Typography
              variant="h6"
              sx={{
                mb: 1,
                fontWeight: 600,
                color: 'white',
              }}
            >
              Server-Log-Dateien
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                lineHeight: 1.6,
              }}
            >
              Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:<br /><br />
              • Browsertyp und Browserversion<br />
              • verwendetes Betriebssystem<br />
              • Referrer URL<br />
              • Hostname des zugreifenden Rechners<br />
              • Uhrzeit der Serveranfrage<br />
              • IP-Adresse<br /><br />
              Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
            </Typography>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default DSGVO;